import { render, staticRenderFns } from "./FormTextLink.vue?vue&type=template&id=ebe52fe2&"
import script from "./FormTextLink.vue?vue&type=script&lang=js&"
export * from "./FormTextLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports